import {
    ADD_COMMENT,
    ADD_COMMENT_FAILURE,
    ADD_COMMENT_SUCCESS,
    CHECK_ALREADY_LIKED,
    DELETE_COMMENT,
    DELETE_COMMENT_SUCCESS,
    EDIT_COMMENT,
    EDIT_COMMENT_SUCCESS,
    GET_COMMENT_COUNT,
    GET_COMMENT_COUNT_SUCCESS,
    GET_COMMENTS,
    GET_COMMENTS_FAILURE,
    GET_COMMENTS_SUCCESS,
    GET_LIKES,
    GET_LIKES_FULFILLED,
    GET_SHARE_SERVICE_URL,
    GET_SHARE_SERVICE_URL_SUCCESS,
    GET_USERS_DATA,
    GET_USERS_DATA_FAILURE,
    GET_USERS_DATA_SUCCESS,
    LIKE_COMMENT,
    LIKE_COMMENT_SUCCESS,
    LIKE_SHARE,
    LIKE_SHARE_SUCCESS,
    ON_CHANGE,
    ONCHANGE_UPDATE_COMMENT,
    SET_UPDATING_COMMENT,
    SHOW_NOTIFICATION,
    UNLIKE_COMMENT,
    UNLIKE_COMMENT_SUCCESS,
    UNLIKE_SHARE,
    UNLIKE_SHARE_SUCCESS,
    UPDATE_COMMENT_CHANGE,
    UPDATE_COMMENT_COUNT
} from './../constants';
import utils from './../utils';
import shareService from '../utils/shareService';
import likesCommentOmnitureCalls from '../utils/likeCommentOmnitureCalls';
import store from '../store';

export const getLikes = (originalSharedProjectGuid) => (dispatch, getState) => {
    console.log('getLikes', originalSharedProjectGuid);
    return {
        type: GET_LIKES,
        payload: utils.getLikes(originalSharedProjectGuid)
            .then((data) => {
                dispatch({
                    type: GET_LIKES_FULFILLED,
                    payload: data
                })
            })
    };
};

export const getUsersData = () => (dispatch, getState) => {
    return {
        type: GET_USERS_DATA,
        payload: utils.getUsersData()
            .then((data) => {
                dispatch({
                    type: GET_USERS_DATA_SUCCESS,
                    payload: data
                });
            })
            .catch((error) => {
                dispatch({type: GET_USERS_DATA_FAILURE})
            })
    }
};

/**
 *
 * @param { String } userIds
 * @param { Array } users
 * Does: checks if given user present in sets of users passed
 */
export const checkIfAlreadyLiked = (userIds, users) => {
    return {
        type: CHECK_ALREADY_LIKED,
        payload: utils.checkIfAlreadyLiked(userIds, users)
    }
};

/**
 * @param { String } userIds
 * @param { Array } users
 * Does: calls the like api for given product
 */
export const likeSharedProduct = (body, users, originalSharedProjectGuid) => (dispatch) => {
    return {
        type: LIKE_SHARE,
        payload: utils.likeSharedProject(body, users, originalSharedProjectGuid)
            .then((data) => {
                dispatch({type: LIKE_SHARE_SUCCESS});
                likesCommentOmnitureCalls.callOmniture('share-product:like project');
            })
    }
};

/**
 * @param {*} userIds
 * @param {*} users
 * Does: Calls the unlike api for the given project
 */

export const unlikeSharedProject = (userIds, users, originalSharedProjectGuid) => (dispatch) => {

    return {
        type: UNLIKE_SHARE,
        payload: utils.unlikeSharedProject(userIds, users, originalSharedProjectGuid)
            .then((data) => {
                dispatch({type: UNLIKE_SHARE_SUCCESS});
                likesCommentOmnitureCalls.callOmniture('share-product:unlike project');
            })
    }
};

export const getComments = (offset, limit, originalSharedProjectGuid) => (dispatch) => {
    return {
        type: GET_COMMENTS,
        payload: utils.getComments(offset, limit, originalSharedProjectGuid)
            .then((comments) => {
                console.log('I should disptach this');
                dispatch({
                    type: GET_COMMENTS_SUCCESS,
                    payload: comments
                })
            })
            .catch((error) => {
                dispatch({
                    type: GET_COMMENTS_FAILURE
                })
            })
    }
}


export const redirectToSignIn = () => {
    const config = {
        redirectUri: window.location.href,
        brand: "sfly",
        source: window.location,
        cid: "2cfd3b76-03da-4391-bc72-b1ad50f97b6a"
    };
    window.$sflyAuth.showSignIn(config);
}

export const redirectToSignUp = () => {

    const config = {
        redirectUri: window.location.href,
        brand: "sfly",
        source: window.location,
        cid: "2cfd3b76"
    };
    window.$sflyAuth.showSignUp(config);
}

/**
 * @param {Object} body
 * Does: call the create comment endpoint with given body
 */

export const addComment = (body, originalSharedProjectGuid) => dispatch => {
    return {
        type: ADD_COMMENT,
        payload: utils.addComment(body, originalSharedProjectGuid)
            .then((comment) => {
                dispatch({
                    type: ADD_COMMENT_SUCCESS,
                    payload: {
                        comment: comment.data,
                        body
                    }
                });
                likesCommentOmnitureCalls.callOmniture('share-product:post comment');
            })
            .catch((error) => {
                dispatch({
                    type: ADD_COMMENT_FAILURE
                })
            })
    }
}

/**
 * @param {String} commentText
 * Does: sets value of comment user is typing
 */

export const onChangeComment = (commentText) => {
    return {
        type: ON_CHANGE,
        payload: {
            commentText
        }
    }
}

/**
 *
 * @param {String} commentId
 * @param {String} body
 * This functions calls utility for calling likeComment API and dispatches success handler
 */
export const likeComment = (commentId, body, originalSharedProjectGuid) => dispatch => {
    return {
        type: LIKE_COMMENT,
        return: utils.likeComment(commentId, body, originalSharedProjectGuid)
            .then((response) => {
                dispatch({
                    type: LIKE_COMMENT_SUCCESS,
                    payload: {
                        commentId,
                        response
                    }
                });
                likesCommentOmnitureCalls.callOmniture('share-product:like comment');
            })
    }
}

/**
 * @param {String} commentId
 * @param {String} likeId
 * @param {String} userId
 * This functions calls utility for calling unikeComment API and dispatches success handler
 */
export const unlikeComment = (commentId, likeId, userId, originalSharedProjectGuid) => dispatch => {
    return {
        type: UNLIKE_COMMENT,
        return: utils.unlikeComment(commentId, likeId, userId, originalSharedProjectGuid)
            .then(() => {
                dispatch({
                    type: UNLIKE_COMMENT_SUCCESS,
                    payload: {
                        commentId,
                        likeId,
                        userId
                    }
                });
                likesCommentOmnitureCalls.callOmniture('share-product:unlike comment');
            })
    }
}


/**
 * @param {String} commentId
 * @param {String} userId
 * Calls deleteComment uitility for given comment by loggedInUser and
 * calls success and error handlers
 */
export const deleteComment = (commentId, userId, originalSharedProjectGuid) => dispatch => {
    return {
        type: DELETE_COMMENT,
        payload: utils.deleteComment(commentId, userId, originalSharedProjectGuid)
            .then((comment) => {
                dispatch({
                    type: DELETE_COMMENT_SUCCESS,
                    payload: commentId
                });

                setTimeout(() => {
                    dispatch({
                        type: SHOW_NOTIFICATION,
                        payload: {
                            flag: false,
                            message: ''
                        }
                    })
                }, 3000);
            })
    }
}

/**
 *
 * @param {*} shareId
 * @param {*} body
 */
export const editComment = (body, originalSharedProjectGuid) => dispatch => {
    return {
        type: EDIT_COMMENT,
        payload: utils.editComment(body, originalSharedProjectGuid)
            .then((res) => {
                dispatch({type: EDIT_COMMENT_SUCCESS, res, body})
            })
    }
}


export const onChangeEditComment = (value) => {
    return {
        type: ONCHANGE_UPDATE_COMMENT,
        payload: value
    }
}


/**
 *
 * @param {Object} comment
 * function to update the editable comment
 */
export const updateCommentChange = (comment) => {

    return {
        type: UPDATE_COMMENT_CHANGE,
        payload: comment
    }
}


/**
 * @param {Object} value
 * Does: sets the current comment user wants to update.
 */
export const setUpdatingComment = (value) => {
    return {
        type: SET_UPDATING_COMMENT,
        payload: value
    }
}

/**
 * Does: calls the API to gets current version of share widget
 */
export const getShareServiceURL = () => dispatch => {
    return {
        type: GET_SHARE_SERVICE_URL,
        payload: shareService.getShareServiceURL()
            .then((resp) => {
                dispatch({
                    type: GET_SHARE_SERVICE_URL_SUCCESS,
                    payload: resp
                })
            })
    }
}

/**
 *
 * @param {*} message
 * @param {*} flag
 * Does: sets reducers flag to true for showing notification
 */
export const showNotification = (message, flag) => {
    return {
        type: SHOW_NOTIFICATION,
        payload: {
            message,
            flag
        }
    }
}

/**
 * @param {*} shareId
 * Does: Calls an endpoint to get total comment
 */
export const getCommentCount = (shareId) => dispatch => {
    return {
        type: GET_COMMENT_COUNT,
        payload: utils.getCommentCount(shareId)
            .then((data) => {
                dispatch({
                    type: GET_COMMENT_COUNT_SUCCESS,
                    payload: data
                })
            })
    }
}

/**
 * @param {Number} count
 */
export const updateCommentsCount = (count) => {
    return {
        type: UPDATE_COMMENT_COUNT,
        payload: count
    }
}


/**
 * dowanloads the library
 */

(function () {

    let href = window.location.href;

    var env = '';
    if (
        href.indexOf("localhost") > -1 ||
        href.indexOf("dev.shutterfly.com") > -1 ||
        href.indexOf("share.shutterfly.com") > -1
    ) {
        env = '-beta';
    } else if (href.indexOf("beta.shutterfly.com") > -1) {
        env = '-beta';
    } else if (href.indexOf("kappa.shutterfly.com") > -1) {
        env = '-kappa';
    } else if (href.indexOf("stage.shutterfly.com") > -1) {
        env = '-stage';

    } else {
        env = '';
    }
    var url = '//cdn' + env + '.staticsfly.com/sfly-sso-client/dist/zuul.js';
    var script = document.createElement('script');
    script.src = url;
    script.onload = () => {
        store.dispatch(getUsersData());
    }
    document.body.appendChild(script);
})();